import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/java': {
    width: 377,
    height: 512,
    paths: [
      {
        d: 'M121.6 396S102 407.4 135.5 411.2C176.1 415.8 196.8 415.2 241.5 406.7 241.5 406.7 253.3 414.1 269.7 420.5 169.5 463.4 42.9 418 121.6 396M109.4 339.9S87.5 356.1 121 359.6C164.3 364.1 198.6 364.4 257.8 353 257.8 353 266 361.3 278.9 365.8 157.6 401.3 22.6 368.7 109.4 339.9M212.6 244.8C237.3 273.2 206.1 298.8 206.1 298.8S268.8 266.4 240 225.9C213.1 188.1 192.5 169.3 304.1 104.6 304.2 104.6 128.9 148.4 212.6 244.8M345.2 437.4S359.7 449.3 329.3 458.6C271.4 476.1 88.5 481.4 37.7 459.3 19.4 451.4 53.7 440.3 64.5 438 75.7 435.6 82.2 436 82.2 436 61.9 421.7-49.1 464.1 25.8 476.2 230 509.4 398.2 461.3 345.2 437.4M131 281.8S37.9 303.9 98 311.9C123.4 315.3 174 314.5 221.1 310.6 259.6 307.4 298.3 300.4 298.3 300.4S284.7 306.2 274.9 312.9C180.4 337.8-2.1 326.2 50.4 300.8 94.9 279.4 131 281.8 131 281.8M298 375.1C394.1 325.2 349.6 277.2 318.6 283.7 311 285.3 307.6 286.7 307.6 286.7S310.4 282.3 315.8 280.4C377.1 258.8 424.3 344 296 377.7 296 377.6 297.5 376.3 298 375.1M240 0S293.2 53.2 189.5 135C106.4 200.6 170.5 238.1 189.5 280.8 141 237 105.4 198.5 129.3 162.6 164.4 110.1 261.5 84.5 240 0M140.5 510.4C232.7 516.3 374.3 507.1 377.6 463.5 377.6 463.5 371.2 480 301.4 493.2 222.7 508 125.6 506.3 68.1 496.8 68.1 496.7 79.9 506.5 140.5 510.4'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/java.js
// module id = 9dGB
// module chunks = 144